import React, { useEffect, useState, useRef } from 'react';
import { gsap } from 'gsap';
import { Button } from 'react-bootstrap';
import { AiFillFire, AiOutlineClose } from "react-icons/ai";
import webDevDescriptions from '../data/webDevDescriptions.js';
import { HashLink } from 'react-router-hash-link';
import '../styles/styles.css'; // Updated CSS file


const services = [
  // Add your services here
  { title: 'Full-Stack Website Development', description: "Our all-in-one service that helps you expand your online presence.", icon: 'full_stack_dev.svg' },
  { title: 'Ongoing Website Modification & Management', description: 'We are experts in managing and enhnacing websites of all different shapes and sizes.', icon: 'ongoing.svg' },
  { title: 'Content Migrations', description: 'Let us remove the stress and hassle of migrating platforms, content, or data.', icon: 'migrations.svg' },
  { title: 'Website Audit', description: 'We offer a uniquely detailed review of your website and online presence. ', icon: 'website_audit.svg' },
  { title: 'Performance & Security', description: 'We specialize in malware removal, server security, and website hardening. ', icon: 'website_security.svg' }
];

const WebDev = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [icons, setIcons] = useState({});
  const overlayRef = useRef(null);

  const openOverlay = (service) => {
    setSelectedService(service);
  };

  const closeOverlay = () => {
    setSelectedService(null);
  };

  const handleContactClick = () => {
    closeOverlay();
    // Delay the navigation to give time for the overlay to close
    setTimeout(() => {
      window.location.hash = 'services#contact';
    }, 300);
  };

  const getDetailedDescription = (title) => {
    return webDevDescriptions.find(desc => desc.title === title);
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the overlay is open and the clicked target is not within the overlay-content
      if (selectedService && overlayRef.current && !overlayRef.current.contains(e.target)) {
        closeOverlay();
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside);
    
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    }
  }, [selectedService]); // Only re-run if selectedService changes

  useEffect(() => {
    const loadIcons = async () => {
      const loadedIcons = {};
      for (const service of services) {
        loadedIcons[service.icon] = (await import(`../assets/img/icons/${service.icon}`)).default;
      }
      setIcons(loadedIcons);
    };

    loadIcons();
  }, []);

  return (
    <div>
      <h1 className="text-center">Website Development & Hosting</h1>
      <div className="web-services-grid-container">
        {services.map((service, index) => (
          <div 
            className="web-services-grid-card" 
            key={index}
            onClick={() => openOverlay(service)}
          >
            {icons[service.icon] && <img src={icons[service.icon]} className='card-img-custom' alt={`${service.title} Icon`} />}  
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
      {selectedService && (
        <div className="overlay">
          <div className="overlay-content" ref={overlayRef}>
            <AiOutlineClose className="overlay-close" onClick={closeOverlay} />
            <div className="overlay-box">
              <h2>{selectedService.title}</h2>
              {getDetailedDescription(selectedService.title).paragraphs.map((para, index) => (
                <p key={index}>{para}</p>
              ))}
              <HashLink to="/services#contact" style={{ textDecoration: 'none'}}>
              <Button 
                className='btn-elegant'
                onClick={handleContactClick}
                >
                  Contact Us
                </Button>
            </HashLink>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WebDev;
